// extracted by mini-css-extract-plugin
export default {"productDescription":"zaa-z","featuredDescription":"Aaa-z","description":"Baa-z","more":"Caa-z","descriptionSku":"Daa-z"};